import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";
import LoadingService from "@/services/LoadingService";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "login",
    component: () => import("@/views/LoginView.vue"),
  },
  {
    path: "/resetDDT",
    name: "resetDDT",
    component: () => import("@/views/ResetDDTView.vue"),
  },
  {
    path: "/resetDDTDemo",
    name: "resetDDTDemo",
    component: () => import("@/views/ResetDDTDemoView.vue"),
  },
  {
    path: "/home",
    name: "home",
    component: () => import("@/views/HomeView.vue"),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "/homeFunction",
        name: "homeFunction",
        component: () => import("@/components/Home/HomeFunctionComponent.vue"),
      },
      {
        path: "/goodsReceipt",
        name: "goodsReceipt",
        component: () => import("@/views/goodsReceipt/GoodsReceiptView.vue"),
      },
      {
        path: "/goodsReceiptDetail/:ddtId/:ddtCode",
        name: "goodsReceiptDetail",
        component: () =>
          import("@/views/goodsReceipt/GoodsReceiptDetailView.vue"),
        props: (route) => ({
          ddtId: Number(route.params.ddtId),
          ddtCode: String(route.params.ddtCode),
        }),
      },
      {
        path: "/goodsReceiptScanHome/:ddtId/:packageCode/:code?",
        name: "goodsReceiptScanHome",
        component: () =>
          import("@/views/goodsReceipt/GoodsReceiptScanHomeView.vue"),
        props: (route) => ({
          ddtId: Number(route.params.ddtId),
          packageCode: String(route.params.packageCode),
          code: route.params.code ? String(route.params.code) : null,
        }),
      },
      {
        path: "/alertReport/:alertId",
        name: "alertReport",
        component: () => import("@/views/Alert/AlertView.vue"),
        props: (route) => ({
          alertId: Number(route.params.alertId),
        }),
      },
      {
        path: "/shop",
        name: "shop",
        component: () => import("@/views/Shop/ShopHomeView.vue"),
      },
      {
        path: "/shopscan",
        name: "shopScan",
        component: () => import("@/views/Shop/Scan/ShopScanView.vue"),
      },
      {
        path: "/shopsearch",
        name: "shopSearch",
        component: () => import("@/views/Shop/Footer/ShopSearchView.vue"),
      },
      {
        path: "/profile",
        name: "profile",
        component: () => import("@/views/Shop/Footer/OrderHistoryView.vue"),
      },
      {
        path: "/cart",
        name: "cart",
        component: () => import("@/views/Shop/Cart/CartView.vue"),
      },
      {
        path: "/ordersdetails/:orderId",
        name: "ordersDetails",
        component: () => import("@/views/Shop/Order/OrdersDetailsView.vue"),
        props: (route) => ({
          orderId: Number(route.params.orderId),
        }),
      },
      {
        path: "/orderhistoryitemdetail/:orderId",
        name: "orderHistoryItemDetail",
        component: () => import("@/views/Shop/Order/OrderHistoryItemView.vue"),
        props: (route) => ({
          orderId: Number(route.params.orderId),
        }),
      },
      {
        path: "/settings",
        name: "settings",
        component: () => import("@/views/SettingsView.vue"),
      },
      {
        path: "/complaint",
        name: "complaint",
        component: () => import("@/views/GoodsPriceComplaintView.vue"),
        props: (route) => {
          const { page, historyNotificationTargetId } = route.query;

          return {
            page: page && Number(page),
            historyNotificationTargetId:
              historyNotificationTargetId &&
              Number(historyNotificationTargetId),
          };
        },
      },
      {
        path: "/backoffice/complaint",
        name: "complaint history",
        component: () => import("@/views/backOffice/BackOfficeView.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  LoadingService.stopLoading();
  await (store as any).restored;
  const token = store.getters["auth/token"];
  if (to.path === "/logout") {
    console.debug("Logging out");
    await store.dispatch("auth/logout");
    console.debug("Redirecting to login page");
    next("/");
    //return;
  } else if (to.meta.requiresAuth && !token) {
    console.debug("Not logged in user -> Redirecting to login page");
    next("/");
  } else if (to.meta.requiresUnauth && !!store.getters["auth/token"]) {
    next("/");
  } else {
    next();
  }
});

export default router;
